import {SET_SERVICE_TYPE_TRANSACTION} from 'shared/constants/ActionTypes';

const initialState = {
  serviceType: {
    id: 'CPU',
    name: 'Cash Pick Up',
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SERVICE_TYPE_TRANSACTION:
      return {
        ...state,
        serviceType: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
